module.exports = __webpack_public_path__ + "static/media/logo.562bff44.png";